import { nanoid } from 'nanoid';

import { State } from '../../../types/video';

export const initialState: State = {
  apiKey: undefined,
  userId: undefined,
  userName: undefined,
  userToken: undefined,
  callId: `${nanoid(10)}`,
  call: undefined,
  client: undefined,
  loading: true,
  feedback: undefined,
  step: 0,
  customControls: false,
  hasJoined: false,
  callState: undefined,
};
